import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const Navbar = ({ restaurants }) => {
  const [links, setLinks] = useState([]);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const { restaurant, id } = useParams();

  const formattedRestaurant = restaurant.replace(/([a-z])([A-Z])/g, "$1 $2");

  const getRestaurentLink = async () => {
    try {
      const response = await axios.get(
        `https://partnermeatwala.com/api/Vendor/getsocialmedia?restid=${id}`
      );

      const { socialmedias } = response?.data;

      if (!socialmedias) {
        throw new Error("No social media links found");
      }

      setLinks(socialmedias);
    } catch (error) {
      console.error("Error fetching restaurant links:", error.message || error);
    }
  };

  useEffect(() => {
    getRestaurentLink();
  }, []);
  return (
    <>
      <header className="th-header header-layout3">
        <div className="menu-top">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-auto">
                <div className="header-logo">
                  <Link to={`/${restaurant}/${id}`}>
                    <img
                      style={{ width: "200px", }}
                      src={`https://partnermeatwala.com/documents/${restaurants?.logo}`}
                      alt={`${restaurant} logo`}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-auto">
                <div className="header-icons">
                  <div className="header-top">
                    <div className="container">
                      <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
                        <div className="col-auto d-none d-lg-block">
                          <div className="header-links">
                            <ul>
                              <li>
                                <div className="social-links">
                                  {links?.map((link, index) => {
                                    let iconClass = "";
                                    if (link.type === "Instagram")
                                      iconClass = "fab fa-instagram";
                                    if (link.type === "Facebook")
                                      iconClass = "fab fa-facebook-f";
                                    if (link.type === "TikTok")
                                      iconClass = "fab fa-tiktok";
                                    if (link.type === "WhatsApp")
                                      iconClass = "fab fa-whatsapp";

                                    return (
                                      <a
                                        key={index}
                                        href={`https://${link.url}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          marginLeft: "10px",
                                        }}
                                      >
                                        <i className={iconClass}></i>
                                      </a>
                                    );
                                  })}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-lg-12 text-center">
                  <nav className="main-menu menu-style1 d-none d-lg-inline-block">
                    <ul>
                      <li>
                        <Link to={`/${restaurant}/${id}`}>Home</Link>
                      </li>
                      <li>
                        <Link to={`/${restaurant}/${id}/menu`}>
                          Order Online
                        </Link>
                      </li>
                      <li>
                        <Link to={`/${restaurant}/${id}/about-us`}>
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link to={`/${restaurant}/${id}/contact-us`}>
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </nav>
                  <button
                    type="button"
                    className="th-menu-toggle d-block d-lg-none"
                    onClick={() => setIsMenuVisible(!isMenuVisible)}
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </div>
              </div>
              {/* Mobile Menu */}
              <div
                className={`th-menu-wrapper ${isMenuVisible ? "th-body-visible" : ""
                  }`}
              >
                <div
                  className="th-menu-area text-center"
                  style={{ position: "relative" }}
                >
                  <button
                    className="th-menu-toggle"
                    style={{
                      backgroundColor: "red",
                      borderRadius: "50%",
                      position: "absolute",
                      right: "-30px",
                    }}
                    onClick={() => setIsMenuVisible(false)}
                  >
                    <i className="fal fa-times"></i>
                  </button>
                  <div className="mobile-logo">
                    <Link to="/">
                      <img
                        style={{ width: "200px" }}
                        src="https://api.asm.skype.com/v1/objects/0-jhb-d11-fe3cb32463ce4eb676800ce937e9e926/views/imgpsh_fullsize_anim"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="th-mobile-menu">
                    <ul>
                      <li>
                        <Link
                          to={`/${restaurant}/${id}`}
                          onClick={() => setIsMenuVisible(false)}
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/${restaurant}/${id}/menu`}
                          onClick={() => setIsMenuVisible(false)}
                        >
                          Order Online
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/${restaurant}/${id}/about-us`}
                          onClick={() => setIsMenuVisible(false)}
                        >
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/${restaurant}/${id}/contact-us`}
                          onClick={() => setIsMenuVisible(false)}
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
